import React, { Component, Fragment } from "react";
import adminService from "../../../Services/adminService";
import userService from "../../../Services/userService";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import config from "../../../config";

import btaxLogo from "../../../assets/images/btaxLogo.png";
import coursesLogo from "../../../assets/images/coursesLogo.png";
import bquickLogo from "../../../assets/images/bquick-logo.png";
import Memberships from "./memberships";

import { COMMENT_LABEL_TYPES, COMMENT_TYPES, USER_COMMENT_COLORS, USER_ROLES } from "../../../global/userConstants.js";

const clientJobOptions = adminService.getClientJobOptions();
const arrivedFromOpts = adminService.getArrivedFromOpts();

class UserCard extends Component {
  state = {
    clientQuestionsListUI: [
      { key: "firstName", label: "שם פרטי" },
      { key: "lastName", label: "שם משפחה" },
      { key: "tzNum", label: "מס' ת.ז" },
      { key: "officeAddress", label: "כתובת" },
      { key: "btaxUserNum", label: "מספר ביטקס" },
      { key: "officeName", label: "שם משרד" }
    ]
  };

  render() {
    const { userData } = this.props;
    return (
      <Fragment>
        <div className="admin-edit-user-inner-cons">
          <div className="client-info-wrapper">
            <div className="office-name-wrapper yellow-color">{userData.officeName}</div>
            <div className="client-info-top relative">
              <h4>
                <i className="material-icons adjust-icons">info</i>
                פרטי לקוח
                <span className="user-card-num">( {userData.cardNum} )</span>
              </h4>
              <div className="card-creation-date center">
                {moment(new Date(userData.dateCreated).toString()).format("DD-MM-YYYY")}
                <br />
                {moment(new Date(userData.dateCreated).toString()).format("HH:mm")}
              </div>
            </div>
            <div className="padding10 nice-scroller-long">
              <table>
                {this.props.focusedViewTypes.includes("btax") ? (
                  <tbody>
                    <tr>
                      <td className="table-cell200">סטטוס ביטקס</td>
                      <td>
                        <FormControl>
                          <Select
                            value={this.props.userStatusesArr.find(({ stateName }) => stateName === userData.btaxStatus)?.stateHeb || ""}
                            onChange={(e) => {
                              this.props.handleStatusChange(
                                "btaxStatus",
                                this.props.userStatusesArr.find(({ stateHeb }) => stateHeb === e.target.value)?.stateName
                              );
                            }}
                            displayEmpty
                          >
                            {this.props.userStatusesArr.map(({ stateHeb: item }) => {
                              return (
                                <MenuItem key={item} value={item}>
                                  {item}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </td>
                    </tr>
                  </tbody>
                ) : null}
                {this.props.focusedViewTypes.includes("bquick") ? (
                  <tbody>
                    <tr>
                      <td>סטטוס Bquick</td>
                      <td>
                        <FormControl>
                          <Select
                            value={this.props.userStatusesArr.find(({ stateName }) => stateName === userData.bquickStatus)?.stateHeb || ""}
                            onChange={(e) => {
                              this.props.handleStatusChange(
                                "bquickStatus",
                                this.props.userStatusesArr.find(({ stateHeb }) => stateHeb === e.target.value)?.stateName
                              );
                            }}
                            displayEmpty
                          >
                            {this.props.userStatusesArr.map(({ stateHeb: item }) => {
                              return (
                                <MenuItem key={item} value={item}>
                                  {item}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </td>
                    </tr>
                  </tbody>
                ) : null}
                {this.props.focusedViewTypes.includes("courses") ? (
                  <>
                    <tbody>
                      <tr>
                        <td>סטטוס סילבר</td>
                        <td>
                          <FormControl>
                            <Select
                              value={
                                this.props.userCoursesStatusesArr.find(({ stateName }) => stateName === userData.silverStatus)?.stateHeb ||
                                ""
                              }
                              onChange={(e) => {
                                this.props.handleStatusChange(
                                  "silverStatus",
                                  this.props.userCoursesStatusesArr.find(({ stateHeb }) => stateHeb === e.target.value)?.stateName
                                );
                              }}
                              displayEmpty
                            >
                              {this.props.userCoursesStatusesArr.map(({ stateHeb: item }) => {
                                return (
                                  <MenuItem key={item} value={item}>
                                    {item}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>סטטוס גולד</td>
                        <td>
                          <FormControl>
                            <Select
                              value={
                                this.props.userCoursesStatusesArr.find(({ stateName }) => stateName === userData.goldStatus)?.stateHeb || ""
                              }
                              onChange={(e) => {
                                this.props.handleStatusChange(
                                  "goldStatus",
                                  this.props.userCoursesStatusesArr.find(({ stateHeb }) => stateHeb === e.target.value)?.stateName
                                );
                              }}
                              displayEmpty
                            >
                              {this.props.userCoursesStatusesArr.map(({ stateHeb: item }) => {
                                return (
                                  <MenuItem key={item} value={item}>
                                    {item}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td>סטטוס פלטינום</td>
                        <td>
                          <FormControl>
                            <Select
                              value={
                                this.props.userCoursesStatusesArr.find(({ stateName }) => stateName === userData.platinumStatus)
                                  ?.stateHeb || ""
                              }
                              onChange={(e) => {
                                this.props.handleStatusChange(
                                  "platinumStatus",
                                  this.props.userCoursesStatusesArr.find(({ stateHeb }) => stateHeb === e.target.value)?.stateName
                                );
                              }}
                              displayEmpty
                            >
                              {this.props.userCoursesStatusesArr.map(({ stateHeb: item }) => {
                                return (
                                  <MenuItem key={item} value={item}>
                                    {item}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                        </td>
                      </tr>
                    </tbody>
                  </>
                ) : null}

                {this.props.focusedViewTypes.includes("btax") || this.props.focusedViewTypes.includes("all") ? (
                  <tbody>
                    <tr>
                      <td>מנהל תיק ביטקס</td>
                      <td>
                        <FormControl>
                          <Select
                            disabled={this.props.isNotEditMode || !this.props.isAllowedEditsInPopup}
                            value={userData.btaxClientOwner || ""}
                            onChange={(e) => {
                              this.props.handleChange({
                                target: {
                                  id: "btaxClientOwner",
                                  value: e.target.value
                                }
                              });
                            }}
                            displayEmpty
                          >
                            <MenuItem value={"כללי"}>כללי</MenuItem>
                            {this.props.salesAccs.map((item) => {
                              return (
                                <MenuItem key={item.email} value={item.email}>
                                  {item.firstName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </td>
                    </tr>
                  </tbody>
                ) : null}

                {this.props.focusedViewTypes.includes("bquick") || this.props.focusedViewTypes.includes("all") ? (
                  <tbody>
                    <tr>
                      <td>מנהל תיק bquick</td>
                      <td>
                        <FormControl>
                          <Select
                            disabled={this.props.isNotEditMode || !this.props.isAllowedEditsInPopup}
                            value={userData.bquickClientOwner || ""}
                            onChange={(e) => {
                              this.props.handleChange({
                                target: {
                                  id: "bquickClientOwner",
                                  value: e.target.value
                                }
                              });
                            }}
                            displayEmpty
                          >
                            <MenuItem value={"כללי"}>כללי</MenuItem>
                            {this.props.salesAccs.map((item) => {
                              return (
                                <MenuItem key={item.email} value={item.email}>
                                  {item.firstName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </td>
                    </tr>
                  </tbody>
                ) : null}

                {this.props.focusedViewTypes.includes("courses") || this.props.focusedViewTypes.includes("all") ? (
                  <tbody>
                    <tr>
                      <td>מנהל תיק קורסים</td>
                      <td>
                        <FormControl>
                          <Select
                            disabled={this.props.isNotEditMode || !this.props.isAllowedEditsInPopup}
                            value={userData.coursesClientOwner || ""}
                            onChange={(e) => {
                              this.props.handleChange({
                                target: {
                                  id: "coursesClientOwner",
                                  value: e.target.value
                                }
                              });
                            }}
                            displayEmpty
                          >
                            <MenuItem value={"כללי"}>כללי</MenuItem>
                            {this.props.salesAccs.map((item) => {
                              return (
                                <MenuItem key={item.email} value={item.email}>
                                  {item.firstName}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </td>
                    </tr>
                  </tbody>
                ) : null}
              </table>
              <hr />
              <table>
                <tbody>
                  <tr>
                    <td>מייל מרכזי</td>
                    <td>
                      <TextField id="email" disabled={this.props.isNotEditMode} value={userData.email || ""} />
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>עיסוק לקוח</td>
                    <td>
                      <FormControl>
                        <Select
                          disabled={this.props.isNotEditMode}
                          value={userData.clientJobTitle}
                          onChange={(e) => {
                            this.props.handleChange({ target: { id: "clientJobTitle", value: e.target.value } });
                          }}
                          displayEmpty
                        >
                          {clientJobOptions.map((item) => {
                            return (
                              <MenuItem key={item.key} value={item.key}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                      {this.clientJobNotInList(userData.clientJobTitle)}
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td>מקור הגעה</td>
                    <td>
                      <FormControl>
                        <Select
                          disabled={this.props.isNotEditMode}
                          value={userData.clientArrivedFrom}
                          onChange={(e) => {
                            this.props.handleChange({ target: { id: "clientArrivedFrom", value: e.target.value } });
                          }}
                          displayEmpty
                        >
                          {arrivedFromOpts.map((item) => {
                            return (
                              <MenuItem key={item.key} value={item.key}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </td>
                  </tr>
                </tbody>
                ליד מלקוח
                {this.state.clientQuestionsListUI.map((item) => {
                  return (
                    <tbody key={item.key}>
                      <tr>
                        <td>{item.label}</td>
                        <td>
                          <TextField
                            onChange={this.props.handleChange}
                            id={item.key}
                            disabled={this.props.isNotEditMode}
                            value={userData[item.key] || ""}
                          />
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
              </table>
              <Memberships
                focusedViewTypes={this.props.focusedViewTypes}
                handleMembershipsChange={this.handleMembershipsChange}
                userData={userData}
                bquickMembers={this.props.bquickMembers}
                btaxMembers={this.props.btaxMembers}
                handleMemberUpdate={this.props.handleMemberUpdate}
                handleMemberChange={this.props.handleMemberChange}
                handleMemberAbilitiesChange={this.props.handleMemberAbilitiesChange}
                tryAddNewMemberAndPushList={this.props.tryAddNewMemberAndPushList}
                initMemberReconf={this.props.initMemberReconf}
                transferMemberToOtherCard={this.props.transferMemberToOtherCard}
                isAllowedEditsInPopup={this.props.isAllowedEditsInPopup}
                resetStations={this.props.resetStations}
              />
            </div>
          </div>
        </div>
        <div className="admin-edit-user-inner-cons">
          <div className="half-height-wrapper">
            <div
              onClick={() => {
                this.props.openCommentsPopup(COMMENT_TYPES.communications);
              }}
              className="last-connections-title-top pointer relative"
            >
              <h4>
                <i className="material-icons adjust-icons">phone</i>
                התקשרויות אחרונות
              </h4>
            </div>

            <div className="padding10 nice-scroller">
              <table className="comments-table">
                {userData.comments.map((comment, index) => {
                  const { commentLabel: label } = comment;
                  return (
                    <tbody
                      key={index}
                      style={{
                        ...(label === COMMENT_LABEL_TYPES.important ? { backgroundColor: USER_COMMENT_COLORS.important.bg } : {})
                      }}
                    >
                      <tr className="small-table-tr-line">
                        <td className="center cell75">
                          <b>
                            {moment(new Date(comment.dateCreated).toString()).format("DD-MM-YYYY")}
                            <br />
                            {moment(new Date(comment.dateCreated).toString()).format("HH:mm")}
                          </b>
                        </td>
                        <td className="cell-comment-txt">
                          <div className="comment-txt-aligner">{this.getHeadlineOfText(comment.commentTxt)}</div>
                        </td>
                        <td className="width45">
                          <div className="blue-circle-background">
                            {adminService.translateAdminName(comment.createdBy, comment.dateCreated)}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
              </table>
            </div>
          </div>

          <div className="half-height-wrapper mt-20">
            <div
              onClick={() => {
                this.props.openCommentsPopup(COMMENT_TYPES.assignments);
              }}
              className="last-open-tasks-top pointer relative"
            >
              <h4>
                <i className="material-icons adjust-icons">format_list_bulleted</i>
                משימות פתוחות
              </h4>
            </div>

            <div className="padding10 nice-scroller">
              <table className="comments-table">
                {this.props.userAssignments
                  ? this.props.userAssignments.filter((assignment) => !assignment.isCompleted).map((assignment, index) => {
                      var dueDate = userService.fixUtcFormat(assignment.dueDate);
                      return (
                        <tbody key={index}>
                          <tr className="small-table-tr-line">
                            <td className="center cell75">
                              <b>
                                {moment(dueDate).format("DD-MM-YYYY")}
                                <br />
                                {moment(dueDate).format("HH:mm")}
                              </b>
                            </td>
                            <td className="cell-comment-txt">
                              <div className="comment-txt-aligner">{this.getHeadlineOfText(assignment.assignmentTxt)}</div>
                            </td>
                            <td className="width45">
                              <div className="blue-circle-background">
                                {adminService.translateAdminName(assignment.createdBy, assignment.dateCreated)}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      );
                    })
                  : null}
              </table>
            </div>
          </div>
        </div>
        <div className="admin-edit-user-inner-cons">
          <div className="half-height-wrapper relative">
            <div className="users-view-type-con">
              <div className="mb-10">
                <button
                  onClick={() => {
                    this.props.changeViewType("all");
                  }}
                  className={`user-view-type-adjust-height${this.props.focusedViewTypes.includes("all") ? " focused-view-btn" : ""}`}
                  style={{ width: "44px" }}
                >
                  הכל
                </button>
              </div>
              <div className="mb-10">
                <button
                  className={`${this.props.focusedViewTypes.includes("btax") ? "focused-view-btn" : ""}`}
                  onClick={() => {
                    this.props.changeViewType("btax");
                  }}
                >
                  <img className="tiny-logo" src={btaxLogo} alt="לוגו btax" />
                </button>
              </div>
              <div className="mb-10">
                <button
                  onClick={() => {
                    this.props.changeViewType("courses");
                  }}
                  className={`user-view-type-adjust-height${this.props.focusedViewTypes.includes("courses") ? " focused-view-btn" : ""}`}
                >
                  <img className="tiny-logo" src={coursesLogo} alt="לוגו קורסים" />
                </button>
              </div>

              {this.isAdmin() && (
                <div>
                  <button
                    onClick={() => {
                      this.props.changeViewType("bquick");
                    }}
                    className={`user-view-type-adjust-height${this.props.focusedViewTypes.includes("bquick") ? " focused-view-btn" : ""}`}
                  >
                    <img className="tiny-logo" src={bquickLogo} alt="לוגו bquick" />
                  </button>
                </div>
              )}
            </div>
            <div
              onClick={() => {
                this.props.openCommentsPopup(COMMENT_TYPES.sales);
              }}
              className="last-sales-con-top pointer relative"
            >
              <h4>
                <i className="material-icons adjust-icons">attach_money</i>
                מכירות אחרונות
              </h4>
            </div>

            <div className="padding10 nice-scroller">
              <table className="table-sales">
                {userData.sales.map((sale, index) => {
                  return (
                    <tbody key={index + 2}>
                      <tr className="small-table-tr-line">
                        <td className="center cell75">
                          <b>
                            {moment(new Date(sale.dateCreated).toString()).format("DD-MM-YYYY")}
                            <br />
                            {moment(new Date(sale.dateCreated).toString()).format("HH:mm")}
                          </b>
                        </td>
                        <td className="cell-comment-txt">{sale.productType}</td>
                        <td>
                          <img className="tiny-logo" alt="" src={this.getRightLogo(sale.commentTags)} />
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
              </table>
            </div>
          </div>

          <div className="half-height-wrapper extended-width-phones mt-20">
            <div className="contact-info-top relative">
              <h4>
                <i className="material-icons adjust-icons">person</i>
                פרטי התקשרות
              </h4>
            </div>

            <div className="padding10 nice-scroller">
              <table id="contact-details-table">
                <thead>
                  <tr>
                    <th className="contact-name">
                      <i className="material-icons ">sentiment_satisfied_alt</i>
                      <div>שם איש קשר</div>
                    </th>
                    <th className="contact-email">
                      <i className="material-icons">alternate_email</i>
                      <div>דוא"ל</div>
                    </th>
                    <th className="contact-name">
                      <i className="material-icons">smartphone</i>
                      <div>מספר</div>
                    </th>
                  </tr>
                </thead>

                {Array.from(Array(7).keys()).map((item, i) => {
                  i++;
                  return (
                    <tbody key={item + "a"} className="fs-17">
                      <tr>
                        <td>
                          {this.props.isNotEditMode ? (
                            <div className="mt-32">
                              <p className="mb-5px">{userData["contactName" + i] || <span className="very-light-gray">(שם)</span>}</p>
                              <hr className="mt-0" />
                            </div>
                          ) : (
                            <div className="mb-15">
                              <TextField
                                id={"contactName" + i}
                                onChange={this.props.handleChange}
                                disabled={this.props.isNotEditMode}
                                value={userData["contactName" + i] || ""}
                              />
                            </div>
                          )}
                        </td>
                        <td className="plr-6">
                          {this.props.isNotEditMode ? (
                            <div className="mt-32">
                              <p className="mb-5px">{userData["contactEmail" + i] || <span className="very-light-gray">(דוא"ל)</span>}</p>
                              <hr className="mt-0" />
                            </div>
                          ) : (
                            <div className="mb-15">
                              <TextField
                                id={"contactEmail" + i}
                                onChange={this.props.handleChange}
                                disabled={this.props.isNotEditMode}
                                value={userData["contactEmail" + i] || ""}
                              />
                            </div>
                          )}
                        </td>
                        <td>
                          {this.props.isNotEditMode ? (
                            <div className="mt-32">
                              <p className="mb-5px">
                                {this.convertPhoneToPretty(userData["mobile" + i]) || "" || <span className="very-light-gray">(מספר)</span>}
                              </p>
                              <hr className="mt-0" />
                            </div>
                          ) : (
                            <div className="mb-15">
                              <TextField
                                onChange={this.props.handleChange}
                                id={"mobile" + i}
                                disabled={this.props.isNotEditMode}
                                value={this.convertPhoneToPretty(userData["mobile" + i]) || ""}
                              />
                            </div>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  getRightLogo = function (logoKey) {
    if (logoKey === "btax") return btaxLogo;
    if (logoKey === "courses") return coursesLogo;
    if (logoKey === "bquick") return bquickLogo;
  };

  isAdmin = function () {
    return localStorage.getItem("role") === USER_ROLES.admin;
  };

  getHeadlineOfText = function (txt) {
    if (!txt) return "";
    return txt.substring(0, Math.min(config.maxLengthOfTxtDesc, txt.length)) + "...";
  };

  clientJobNotInList = (clientJob) => {
    for (const job of clientJobOptions) {
      if (clientJob === job.key) return "";
    }
    return <span className="mr-10">{clientJob} (עבר מהכוורת)</span>;
  };

  convertPhoneToPretty = (number) => {
    if (!number) return "";
    number = number.toString();
    number = number.replace(/-/g, "");
    if (number.length === 9) return number.substring(0, 2) + "-" + number.substring(2, number.length);
    if (number.length === 10) return number.substring(0, 3) + "-" + number.substring(3, 6) + "-" + number.substring(6, number.length);
    return number;
  };
}

export default UserCard;
